// extracted by mini-css-extract-plugin
export default {"breakdowntitle":"gl","result_page":"hl","what_are_calories":"il","title":"jl","copy":"kl","chart":"ll","to_reach":"ml","title_wrapper":"nl","rhode_percent":"ol","what_are_macro":"pl","text":"ql","img":"rl","macros_wrapper":"sl","macros":"tl","macro_item":"ul","value":"vl","note":"wl","btn":"xl","carbo_item":"yl","faq":"zl","faq_items":"Al"};
    if(module.hot) {
      // 1715632473105
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  